<template>
     <v-layout v-resize="onResize" column style="padding-top: 56px">
  <div class="col-md-12">
    <div class="card">
      <div class="card-header">Inquiry Huangyi</div>
      <div class="card-body">
        <!-- show-select -->
        <v-dialog v-model="dialogLoading" width="150px" height="auto">
          <v-card width="150px" height="150px" style="text-align: center">
            <v-progress-circular
              :size="70"
              :width="7"
              color="orange"
              indeterminate
              persistent
              style="margin-top: 40px"
            ></v-progress-circular>
          </v-card>
        </v-dialog>
     
          <v-data-table
            item-key="ID_TRX"
            :headers="headers"
            :items="users"
            :hide-default-header="isMobile"
            :class="{mobile: isMobile}"
            :search="search"
          >
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-row>
                  <v-btn
                    style="margin-right: 20px"
                    color="#FCC133"
                    dark
                    @click="newuser"
                    >New User</v-btn
                  >
                  <v-btn
                    color="#FF7043"
                    dark
                   style="margin-right: 20px"
                    @click="export_data"
                  >
                    Export All Data User
                  </v-btn>
                </v-row>
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search Huang Yi Data"
                  single-line
                  hide-details
                  color="#F9A825"
                ></v-text-field>

                <v-dialog
                  v-model="dialog"
                  v-if="dialog"
                  max-width="98%"
                  persistent
                >
                  <template v-slot:activator="{ on, attrs }"> </template>
                  <v-card>
                    <FormDaftarHuang
                      @onCloseDialog="onCloseDialog"
                      :data="{ editedItem }"
                    ></FormDaftarHuang>
                  </v-card>
                </v-dialog>
                <v-dialog
                  v-model="dialog3"
                  v-if="dialog3"
                  max-width="35%"
                  persistent
                >
                  <v-card>
                    <FormUploadSignature
                      @onCloseDialog="onCloseDialog"
                      :dataTaoyu="{ users }"
                      :idDatatable="id_data_table"
                    ></FormUploadSignature>
                  </v-card>
                </v-dialog>
                <v-dialog
                  v-model="dialog4"
                  v-if="dialog4"
                  max-width="70%"
                  persistent
                >
                  <DataTableHistory
                  @onCloseDialog="onCloseDialog"
                  :idDatatable="id_data_table2"
                  ></DataTableHistory>
                </v-dialog>
              </v-toolbar>
            </template>

            <template v-slot:item.TGL_DAFTAR="{ item }">
              <span
                >{{ new Date(item.TGL_DAFTAR).toLocaleDateString('es-CL') }}</span
              >
            </template>

            <template v-slot:item.updated_at="{ item }">
              <span
                >{{ new Date(item.updated_at).toLocaleString('es-CL') }}</span
              >
            </template>

            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="editItem(item)">
                mdi-pencil
              </v-icon>
              <v-icon small class="mr-2" @click="deleteItem(item)">
                mdi-delete
              </v-icon>
              <v-icon small class="mr-2" @click="printProfile(item)">
                mdi-printer
              </v-icon>
              <v-icon small class="mr-2" @click="uploadSignature(item)">
                mdi-upload
              </v-icon>
              <v-icon small class="mr-2" @click="showHistory(item)">
                mdi-history
              </v-icon>
            </template>
            <template v-slot:no-data>
              <!-- <v-btn color="#FCC133" @click="initialize">Reset</v-btn> -->
            </template>
          </v-data-table>
       
      </div>
    </div>
  </div>
   </v-layout>
</template>

<script>
import axios from '@/axios'
import FormDaftarHuang from '../../components/modal/FormDaftarHuang.vue'
import FormUploadSignature from '../../components/modal/FormUploadSignature.vue'
import DataTableHistory from '../../components/modal/DataTableHistory.vue'
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/src/sweetalert2.scss'
export default {
    data: () => ({
        dialog: false,
        dialog3: false,
        dialog4: false,
        isMobile: false,
        dialogLoading:false,
        search: '',
        headers: [
        { text: 'No HuangYi', value: 'NO_HUANGYI', filterable: true },
        { text: 'Name', align: 'start',value: 'NAMA_INDO',},
        { text: 'Chinese Name (Pinyin)', value: 'NAMA_PINYIN' },
        { text: 'Chinese Name (Hanzi)', value: 'NAMA_HANZI' },
        // { text: 'Created By', value: 'CREATED_NAME', filterable: false },
          { text: 'Created By', value: 'LAST_UPDATE_NAME', filterable: false },
        { text: 'Last Updated', value: 'updated_at', filterable: false },
        // { text: 'Updated By', value: 'NO_TAOYU', filterable: false },
        { text: 'Actions', value: 'actions', sortable: false },
        ],
        users:[],
        editedItem: [],
        role:0,
        statusDialog:0,
        id_data_table:0,
        id_data_table2:0
    }),
    watch: {
        dialog (val) {val || this.close()},
    },
    created () {
        this.initialize()
    },
    beforeCreate: function () {
        if (!this.$session.exists()) {
        this.$router.push('/')
        }
    },
    methods: {
        onResize() {
          if (window.innerWidth < 769)
            this.isMobile = true;
          else
            this.isMobile = false;
        },
        initialize () {
            // console.log('Dash '+this.$session.get('token'));
            if(this.$session.get('role'))this.role=this.$session.get('role');
            this.users=[];

            axios({
                method: 'post',
                url: 'list_data_table',
                data: {
                  role_name: 'HuangYi',
                  user_id:this.$session.get('user_id')
                },
                headers: {
                  Authorization: 'Bearer ' + this.$session.get('token'),
                },
            }).then(response => {
                this.users=response.data;
            }).catch(error=>{
                console.log('Error Fetch Data '+error);
            });
        },
        export_data(){

            const swalWithBootstrapButtons = Swal.mixin({
                                              customClass: {
                                                confirmButton: 'btn btn-success',
                                                cancelButton: 'btn btn-danger'
                                              },
                                              buttonsStyling: false
                                            })

            swalWithBootstrapButtons.fire({
             // title: 'Are you sure?',
              text: "Are you sure?",
              icon: 'warning',
              showCancelButton: true,
              confirmButtonText: 'Yes, export to csv!',
              cancelButtonText: 'No, cancel!',
              reverseButtons: true
            }).then((result) => {
              if (result.isConfirmed) {
                axios({
                    method: 'get',
                    url: 'export_all_data_huangyi',
                    responseType: 'blob', // important
                    headers: {
                      Authorization: 'Bearer ' + this.$session.get('token'),
                    },
                  }).then(response => {
                      const url = window.URL.createObjectURL(new Blob([response.data]));
                      const link = document.createElement('a');
                      link.href = url;
                      link.setAttribute('download', 'ExportAllData.csv');
                      document.body.appendChild(link);
                      link.click();
                      this.dialogLoading=false;
                  }).catch(error => {
                      console.log(error.response);
                      this.dialogLoading=false;
                  });
              } else if (
                /* Read more about handling dismissals below */
                result.dismiss === Swal.DismissReason.cancel
              ) {
                swalWithBootstrapButtons.fire(
                  'Cancelled',
                  'It is okay :)',
                  'info'
                )
                 this.dialogLoading=false;
              }
            })
            
        },
        close () {
            this.dialog = false
            this.$nextTick(() => {
            this.editedIndex = -1
            })
        },
        newuser(){
            this.dialog=true;
        },
        onCloseDialog(){
            this.dialog = false;
            this.dialog3 = false;
            this.dialog4 = false;
            this.initialize()
        },
        editItem (item) {
            this.editedIndex = this.users.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.dialog = true
        },
        deleteItem (item) {
            confirm('Are you sure you want to delete this item?') &&
            axios({
                method: 'post',
                url: 'delete_data_table',
                data: {
                  id: item.ID_TRX,
                },
                headers: {
                  Authorization: 'Bearer ' + this.$session.get('token'),
                },
            }).then(response => {
                if(response.data){
                    Swal.fire({
                                title:'Peringatan',
                                icon :'success',
                                text:response.data
                        });
                    this.initialize()
                }
                console.log(response);
            }).catch(error => {
                console.log(error.response);
            });
        },
        printProfile(item){
            this.dialogLoading=true;
            const swalWithBootstrapButtons = Swal.mixin({
                                              customClass: {
                                                confirmButton: 'btn btn-success',
                                                cancelButton: 'btn btn-danger'
                                              },
                                              buttonsStyling: false
                                            })

            swalWithBootstrapButtons.fire({
             // title: 'Are you sure?',
              text: "Are you sure?",
              icon: 'warning',
              showCancelButton: true,
              confirmButtonText: 'Yes, download pdf!',
              cancelButtonText: 'No, cancel!',
              reverseButtons: true
            }).then((result) => {
              if (result.isConfirmed) {
                axios({
                    method: 'post',
                    url: 'profile_data',
                    headers: {
                      Authorization: 'Bearer ' + this.$session.get('token'),
                    },
                    responseType: 'blob', // important
                    data:{
                        id: item.ID_TRX
                    },
                    
                }).then(response => {
                    // console.log(response);
                    if(response){
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', item.NAMA_INDO+'.pdf');
                        document.body.appendChild(link);
                        link.click();
                        this.dialogLoading=false;
                        // this.initialize();
                    }
                }).catch(error => {
                    this.dialogLoading=false;
                    console.log(error.response);
                });
              } else if (
                /* Read more about handling dismissals below */
                result.dismiss === Swal.DismissReason.cancel
              ) {
                swalWithBootstrapButtons.fire(
                  'Cancelled',
                  'It is okay :)',
                  'info'
                )
                this.dialogLoading=false;
              }
            })
            // this.dialogLoading=true;
            // confirm('Are you sure to print this profile ?') &&
            // axios({
            //     method: 'post',
            //     url: 'http://sd6webdev.indomaret.lan/laravel-passport/public/api/profile_data',
            //     responseType: 'blob', // important
            //     data:{
            //         id: item.ID_TRX
            //     },
            //     headers: {
            //       Authorization: 'Bearer ' + this.$session.get('token'),
            //     },
            // }).then(response => {
            //     // console.log(response);
            //     if(response){
            //         const url = window.URL.createObjectURL(new Blob([response.data]));
            //         const link = document.createElement('a');
            //         link.href = url;
            //         link.setAttribute('download', item.NAMA_INDO+'.pdf');
            //         document.body.appendChild(link);
            //         link.click();
            //         this.dialogLoading=false;
            //         // this.initialize();
            //     }
            // }).catch(error => {
            //     this.dialogLoading=false;
            //     console.log(error.response);
            //});
        },
        uploadSignature (item){
          this.id_data_table = item.ID_TRX;
          this.dialog3=true;
        },
        showHistory(item){
          this.id_data_table2 = item.ID_TRX;
          this.dialog4 = true;
        }
    },
    components: {
        FormDaftarHuang,
        FormUploadSignature,
        DataTableHistory
    },
}
</script>

<style>
.butt {
  padding: 10px;
  background-color: #ebaa1f;
}

.mobile {
  color: #333;
}

@media screen and (max-width: 768px) {
  .mobile table.v-table tr {
    max-width: 100%;
    position: relative;
    display: block;
  }

  .mobile table.v-table tr:nth-child(odd) {
    border-left: 6px solid deeppink;
  }

  .mobile table.v-table tr:nth-child(even) {
    border-left: 6px solid cyan;
  }

  .mobile table.v-table tr td {
    display: flex;
    width: 100%;
    border-bottom: 1px solid #f5f5f5;
    height: auto;
    padding: 10px;
  }

  .mobile table.v-table tr td ul li:before {
    content: attr(data-label);
    padding-right: 0.5em;
    text-align: left;
    display: block;
    color: #999;
  }
  .v-datatable__actions__select {
    width: 50%;
    margin: 0px;
    justify-content: flex-start;
  }
  .mobile .theme--light.v-table tbody tr:hover:not(.v-datatable__expand-row) {
    background: transparent;
  }
}
.flex-content {
  padding: 0;
  margin: 0;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}

.flex-item {
  padding: 5px;
  width: 50%;
  height: 40px;
  font-weight: bold;
}
</style>
